/*
 *
 *  actions
 *
 */

import {
  LOAD_CASH_BANK_DETAILS,
  LOAD_CASH_BANK_DETAILS_SUCCESS,
  LOAD_CASH_BANK_DETAILS_ERROR,
  LOAD_CASH_IN_HAND_TRANSACTION,
  LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS,
  LOAD_CASH_IN_HAND_TRANSACTION_ERROR,
  LOAD_ACCOUNT_TRANSACTION_DETAILS,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR,
  LOAD_CASH_BANK_TOTAL_LIST,
  LOAD_CASH_BANK_TOTAL_LIST_SUCCESS,
  LOAD_CASH_BANK_TOTAL_LIST_ERROR,
  LOAD_TOTAL_CASH_BANK_TRANSACTION,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR,
  LOAD_CASH_IN_HAND_LIST,
  LOAD_CASH_IN_HAND_LIST_SUCCESS,
  LOAD_CASH_IN_HAND_LIST_ERROR,
  CREATE_CASH_BANK_DETAILS,
  CREATE_CASH_BANK_DETAILS_SUCCESS,
  CREATE_CASH_BANK_DETAILS_ERROR,
  UPDATE_CASH_BANK_DETAILS,
  UPDATE_CASH_BANK_DETAILS_SUCCESS,
  UPDATE_CASH_BANK_DETAILS_ERROR,
  DELETE_CASH_BANK_DETAILS,
  DELETE_CASH_BANK_DETAILS_SUCCESS,
  DELETE_CASH_BANK_DETAILS_ERROR,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR,
} from "./constants";

// load payment in
export function loadCashBankList(paymentDetails) {
  return {
    type: LOAD_CASH_BANK_DETAILS,
    paymentDetails,
  };
}

export function loadCashBankListSuccess(cash_bank_details, success) {
  return {
    type: LOAD_CASH_BANK_DETAILS_SUCCESS,
    cash_bank_details,
    success,
  };
}

export function loadCashBankListError(error) {
  return {
    type: LOAD_CASH_BANK_DETAILS_ERROR,
    error,
  };
}
// load payment in
export function loadCashBankTotalList(paymentDetails) {
  return {
    type: LOAD_CASH_BANK_TOTAL_LIST,
    paymentDetails,
  };
}

export function loadCashBankTotalListSuccess(cash_bank_total, success) {
  return {
    type: LOAD_CASH_BANK_TOTAL_LIST_SUCCESS,
    cash_bank_total,
    success,
  };
}

export function loadCashBankTotalListError(error) {
  return {
    type: LOAD_CASH_BANK_TOTAL_LIST_ERROR,
    error,
  };
}

// Total Transactions
export function loadTotalCashBankTransaction(paymentDetails) {
  return {
    type: LOAD_TOTAL_CASH_BANK_TRANSACTION,
    paymentDetails,
  };
}

export function loadTotalCashBankTransactionSuccess(total_cash_bank, success) {
  return {
    type: LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS,
    total_cash_bank,
    success,
  };
}

export function loadTotalCashBankTransactionError(error) {
  return {
    type: LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR,
    error,
  };
}
// load parties
export function loadCashInHandTransaction(paymentDetails) {
  return {
    type: LOAD_CASH_IN_HAND_TRANSACTION,
    paymentDetails,
  };
}

export function loadCashInHandTransactionSuccess(
  cash_in_hand_details,
  success
) {
  return {
    type: LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS,
    cash_in_hand_details,
    success,
  };
}

export function loadCashInHandTransactionError(error) {
  return {
    type: LOAD_CASH_IN_HAND_TRANSACTION_ERROR,
    error,
  };
}

//payment in report

// load payment in
export function loadAccountTransactionList(paymentDetails) {
  return {
    type: LOAD_ACCOUNT_TRANSACTION_DETAILS,
    paymentDetails,
  };
}

export function loadAccountTransactionListSuccess(
  account_transaction_list,
  success
) {
  return {
    type: LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
    account_transaction_list,
    success,
  };
}

export function loadAccountTransactionListError(error) {
  return {
    type: LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR,
    error,
  };
}

// load account
export function loadCashInHandList(paymentDetails) {
  return {
    type: LOAD_CASH_IN_HAND_LIST,
    paymentDetails,
  };
}

export function loadCashInHandListSuccess(cash_hand_list, success) {
  return {
    type: LOAD_CASH_IN_HAND_LIST_SUCCESS,
    cash_hand_list,
    success,
  };
}

export function loadCashInHandListError(error) {
  return {
    type: LOAD_CASH_IN_HAND_LIST_ERROR,
    error,
  };
}

// load parties
export function createCashBankList(paymentDetails) {
  return {
    type: CREATE_CASH_BANK_DETAILS,
    paymentDetails,
  };
}

export function createCashBankListSuccess(paymentDetails, success) {
  return {
    type: CREATE_CASH_BANK_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function createCashBankListError(error) {
  return {
    type: CREATE_CASH_BANK_DETAILS_ERROR,
    error,
  };
}
// load parties
export function updateCashBankList(paymentDetails) {
  return {
    type: UPDATE_CASH_BANK_DETAILS,
    paymentDetails,
  };
}

export function updateCashBankListSuccess(paymentDetails, success) {
  return {
    type: UPDATE_CASH_BANK_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function updateCashBankListError(error) {
  return {
    type: UPDATE_CASH_BANK_DETAILS_ERROR,
    error,
  };
}
// load parties
export function deleteCashBankList(paymentDetails) {
  return {
    type: DELETE_CASH_BANK_DETAILS,
    paymentDetails,
  };
}

export function deleteCashBankListSuccess(paymentDetails, success) {
  return {
    type: DELETE_CASH_BANK_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function deleteCashBankListError(error) {
  return {
    type: DELETE_CASH_BANK_DETAILS_ERROR,
    error,
  };
}

export function loadCashBankListRecordsMetaData() {
  return {
    type: LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadCashBankListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadCashBankListRecordsMetaDataError(error) {
  return {
    type: LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadCashBankList,
  loadCashBankListSuccess,
  loadCashBankListError,

  loadAccountTransactionList,
  loadAccountTransactionListSuccess,
  loadAccountTransactionListError,

  loadCashBankTotalList,
  loadCashBankTotalListSuccess,
  loadCashBankTotalListError,

  loadTotalCashBankTransaction,
  loadTotalCashBankTransactionSuccess,
  loadTotalCashBankTransactionError,

  loadCashInHandList,
  loadCashInHandListSuccess,
  loadCashInHandListError,

  createCashBankList,
  createCashBankListSuccess,
  createCashBankListError,
  updateCashBankList,
  updateCashBankListSuccess,
  updateCashBankListError,

  deleteCashBankList,
  deleteCashBankListSuccess,
  deleteCashBankListError,

  loadCashBankListRecordsMetaData,
  loadCashBankListRecordsMetaDataSuccess,
  loadCashBankListRecordsMetaDataError,
  loadCashInHandTransaction,
  loadCashInHandTransactionSuccess,
  loadCashInHandTransactionError,
};

export default actions;
